import React from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';
import Table from 'react-bootstrap/Table';
import { FaPencilAlt } from 'react-icons/fa';

import PropertyAPI from '../../api/PropertyAPI';

import ApiUiController from '../../controller/ApiUiController';
import Display from '../../util/Display';
import withRouter from '../../util/WithRouter';
import Util from '../../util/Util';
import ContactConst from '../../util/ContactConst';
import Const from '../../util/Constants';

class InnerPropertyList extends React.Component {
  constructor(props) {
    super(props);
    this.model = reactLocalStorage.getObject(Const.Model).property;
    this.state = { inApiCall: true, properties: [] };
    this.Update = Util.isAllow(this.model.permission, Const.PermUpdate);
    this.Delete = Util.isAllow(this.model.permission, Const.PermDelete);
  }

  componentDidMount() {
    this.loadProperties();
  }

  UNSAFE_componentWillReceiveProps(props) {
    if (props.lead && props.lead.id !== this.id) {
      this.loadProperties();
    }
  }

  loadProperties = () => { PropertyAPI.getInnerContactList(this.props.id,this.onReceived); }

  onReceived = res => { this.setState({ inApiCall: false, properties: res.data });}
  onDelete = indx => Util.confirmAlert('Delete', 'Are you sure you want to delete', 'Delete', 'No',
    () => {
      this.setState({ ...this.state, inApiCall: true });
      PropertyAPI.delete(this.state.properties[indx].id, this.onDeleteSuccess,
        this.props.failure, this.props.logout);
    });
  onDeleteSuccess = () => {
    Util.showNotification('Successful', 'Property deleted successfully', 'success');
    this.props.reload();
  }

  showList = () => this.state.properties.map((property, _i) => (
      <tr key={`property_${_i + 1}`}>
        <td>{Display.FieldValue(property, 'name', this.model.fields)}</td>
        <td>{Display.FieldValue(property, 'property_type', this.model.fields)}</td>
        <td> {Display.FieldValue(property, 'price', this.model.fields)} </td>
        <td> {property.build_area} </td>
        <td> {Display.ModelLabelValue('user', property.created_by)} </td>
        <td> {Display.FieldValue(property, 'created_date', this.model.fields)} </td>
        <td> {Display.ModelLabelValue('user', property.updated_by)} </td>
        <td> {Display.FieldValue(property, 'updated_date', this.model.fields)} </td>
        <td>
          {this.Update ? <span className="buttons update" onClick={() => 
            this.props.edit(property, ContactConst.Property)}> <FaPencilAlt /> Edit </span>
            : null
          }
        </td>
      </tr>
    ));

  render() {
    let uiCalls = this.showList();
    if (this.state.properties.length === 0) {
      uiCalls = <tr> <td colSpan="9">No Records Found</td> </tr>;
    }
    return (
      <div className="row">
        <div className="col-md-12">
          <h2>Properties</h2>
          <ApiUiController inApiCall={this.state.inApiCall}>
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Type</th>
                  <th>Price</th>
                  <th>Build Area(in Sq. ft.)</th>
                  <th>Created By</th>
                  <th>Created Date</th>
                  <th>Updated By</th>
                  <th>Updated Date</th>
                  <th className="actionth">Action</th>
                </tr>
              </thead>
              <tbody>{uiCalls}</tbody>
            </Table>
          </ApiUiController>
        </div>
      </div>
    );
  }
}

export default withRouter(InnerPropertyList);
